import styled from 'styled-components';

import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${sizes.wizardContentWidth}px;
  margin-bottom: ${themeSpacing.sm3};
`;
